<template>
  <div>
    <PrimaryButton @click.native="openDialog" light full-width>
      Add Reference
      <v-icon>mdi-plus</v-icon>
    </PrimaryButton>
    <AddReferenceDialog
      v-if="isOpen"
      :isOpen="isOpen"
      :candidate="candidate"
      @created="handleCreated"
      @close="closeDialog"
    />
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import AddReferenceDialog from "@/views/offers/components/compliances/dialogs/ReferenceDialog";

export default {
  props: {
    candidate: {
      type: Object,
      required: true
    }
  },
  components: {
    AddReferenceDialog,
    PrimaryButton
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    },
    handleCreated(newReference) {
      this.$emit("created", newReference);
    }
  }
};
</script>
